// extracted by mini-css-extract-plugin
export default {"form":"form__elIRRWxREtGCSvrNPl_Q","title":"title__YooSHogeAzn6y7LoiyKM","subtitle":"subtitle__Di1AG76kqOm45GDTaFAK"};